import { render, staticRenderFns } from "./ApplicantEditKnowledge.vue?vue&type=template&id=e324eff8&"
import script from "./ApplicantEditKnowledge.vue?vue&type=script&lang=js&"
export * from "./ApplicantEditKnowledge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports